import { render } from "./mobile-menu-open.vue?vue&type=template&id=1af6ede2"
import script from "./mobile-menu-open.vue?vue&type=script&lang=js"
export * from "./mobile-menu-open.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__